import Lottie from "lottie-react";
import loading from "./loading.json";
const LoadingReact = () => {
  return (
      <Lottie className="h-52" animationData={loading} loop={true} />
  );
};

export default LoadingReact;
